export const preCreatingEditValues = (data, financial_structure) => {
  const {name, waterfall_items} = financial_structure;
  let result = {
    name,
    waterfall_items: [],
  };
  const dataValues = Object.values(data);
  let count = 2;

  waterfall_items.map((item) => {

    const itemKeys = Object.keys(item.data);
    const itemValues = Object.values(item.data);
    const waterfall_item = {
      data: {},
      waterfall_item_id: item.waterfall_item_id
    };

    itemKeys.map((key, i) => {
      if (itemValues[i].type === 'integer' || itemValues[i].type === 'number') {
        waterfall_item.data[key] = +dataValues[count + i];
      } else {
        waterfall_item.data[key] = dataValues[count + i];
      }
    });
    result.waterfall_items.push(waterfall_item);
    count += itemKeys.length;

  });
  return result;
};

export const rowAndColDefination = (financial_structure, finStrIndex,scenarioShow) => {
  const {id, previous_id, name} = financial_structure;
  const waterfall_items = financial_structure.waterfall_items ?
    financial_structure.waterfall_items
    :financial_structure.scenario_fin_struct_waterfall_items;
  let rowObj = {finStrId: id, inputType: name};
  let colDef = [{
    headerName: 'Name',
    field: 'inputType',
    width: 150,
    editable: false,
    finStrIndex,
    financial_structure,
    cellRendererSelector: () => {
      if(!scenarioShow){
        return {
          component: 'customIcons',
          params: {id: previous_id ? previous_id : id, name}
        };
      }
      return null;
    },
  }];

  waterfall_items.map((item, j) => {
      const keys = Object.keys(item.data);
      const values = Object.values(item.data);
      keys.map((key, i) => {
        rowObj[key + j] = values[i].value;
        colDef.push({
          headerName: key,
          field: key + j,
          editable: true,
          scenarioShow,
          cellRendererSelector: () => {
            const {type} = values[i];
            if (type !== 'boolean') {
              return {component: 'simpleInputAgGridRenderer', params: {id, finStrIndex}}
            }
            return null;
          },
          cellEditorSelector: (params) => {
            const {type} = values[i];
            if (type !== 'boolean') {
              return {
                component: 'simpleInputAgGridEditor',
                params: {id, type, required: item.required.includes(key) ? true : false, finStrIndex}
              }
            }
            return {component: 'checkboxAgGridEditor', params};
          }
        });
      });
    }
  );
  return {rowObj, colDef}
};


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomFinStr/helpers.js